import { render } from "./programsComponent.vue?vue&type=template&id=4f16c419&scoped=true"
import script from "./programsComponent.vue?vue&type=script&lang=js"
export * from "./programsComponent.vue?vue&type=script&lang=js"

import "./programsComponent.vue?vue&type=style&index=0&id=4f16c419&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f16c419"]])

export default __exports__